const config = {
  // baseUrl: "http://localhost:3001/api",
  baseUrl: "https://microtask-counter-backend.onrender.com/api",
};
export default config;
